<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>The Italian’s Ruthless Marriage Bargain</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="halfTitlePage" id="htp01"><a id="page05"><h2 class="halfTitlePageTitle"><span class="bold"><span>THE ITALIAN’S RUTHLESS MARRIAGE BARGAIN</span></span></h2></a></div>
<a id="page05">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// italiansruthlessmarriagebargainthe_htp01.vue?062f50d9